import React from 'react';
import { Grid, Typography, Box } from '@mui/material';

const NewsTable = ({ publisher, time, headline, content }) => {
    return (
        <>
            <Grid item xs={2} style={{ borderTop: 'solid 1px', marginTop: '20px' }}>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant={'h5'}>{publisher}</Typography>
                    <Typography variant={'h5'}>{time}</Typography>
                </Box>
            </Grid>
            <Grid item xs={5} style={{ borderTop: 'solid 1px', marginTop: '20px' }}>
                <Typography style={{ float: 'right' }} variant={'h5'}>{headline}</Typography>
            </Grid>
            <Grid item xs={5} style={{ borderTop: 'solid 1px', marginTop: '20px' }} />
            <Grid item xs={12}>
                <Typography variant={'body1'}>{content}</Typography>
            </Grid>
        </>
    );
};

export default NewsTable;
